import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ChevronRight, Calendar, Activity } from 'lucide-react';
import { format } from 'date-fns';

export function UpcomingWorkouts() {
  const workouts = [
    {
      id: 1,
      client: 'Sarah Chen',
      type: 'Strength Training',
      time: '10:30 AM',
      duration: '60 min'
    },
    {
      id: 2,
      client: 'Mike Johnson',
      type: 'HIIT Session',
      time: '2:00 PM',
      duration: '45 min'
    },
    {
      id: 3,
      client: 'Emma Wilson',
      type: 'Recovery',
      time: '4:30 PM',
      duration: '30 min'
    }
  ];

  return (
    <div className="theme-card p-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
      
      <div className="relative">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <Calendar className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold">Today's Schedule</h2>
          </div>
          <div className="text-sm text-muted-foreground">
            {format(new Date(), 'EEEE, MMM d')}
          </div>
        </div>

        <div className="space-y-4">
          {workouts.map((workout, index) => (
            <motion.div
              key={workout.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-muted/30 p-4 rounded-lg group hover:bg-muted/50 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-2">
                <div>
                  <div className="font-medium">{workout.client}</div>
                  <div className="text-sm text-muted-foreground">{workout.type}</div>
                </div>
                <ChevronRight className="w-5 h-5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1">
                  <Clock className="w-4 h-4 text-primary" />
                  <span>{workout.time}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Activity className="w-4 h-4 text-primary" />
                  <span>{workout.duration}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <button className="w-full theme-button py-3 rounded-lg mt-4 flex items-center justify-center gap-2">
          <Calendar className="w-4 h-4" />
          View Full Schedule
        </button>
      </div>
    </div>
  );
}